import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import UserService from '../Services/UserService';
import {extractErrorMessage} from '../Services/RequestService';
import { replaceInCollection} from './utils';
import { userTypes } from "../CommonConstants";

export const useAdministrators = () => {
    const [administrators, setAdministrators] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            let resp = await UserService.allUsers(token);
            let admins = resp.data.filter((user) => {
                return user.type === userTypes.admin.type
            }).map(({ id, name, email, active }) => {
                return { id, name, email, active };
            });
            setAdministrators(admins);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addAdministrator = async (admin) => {
        try {
            admin.type = userTypes.admin.type;
            let resp = await UserService.addUser(admin, token);
            delete admin.password
            setAdministrators([...administrators, {...admin, id: resp.data.id}]);
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateAdministrator = async (admin) => {
        try {
            admin.type = userTypes.admin.type;
            await UserService.updateUser(admin, token);
            setAdministrators(replaceInCollection(admin, administrators));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const disableAdministrator = async (admin) => {
        try {
            await UserService.disableUser(admin.id, token);
            admin.active = false;
            setAdministrators(replaceInCollection(admin, administrators));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const enableAdministrator = async (admin) => {
        try {
            await UserService.enableUser(admin.id, token);
            admin.active = true;
            setAdministrators(replaceInCollection(admin, administrators));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [administrators, addAdministrator, updateAdministrator, disableAdministrator, enableAdministrator];
}


// WEBPACK FOOTER //
// ./src/Hooks/useAdministrators.js